import React from "react";
import PermissionEnum from "../../controllers/PermissionEnum";
import FarmersSamplesTab from "../farmersamples/FarmersSamplesTab";
import EntriesBase from "../BaseFarmersAndSoil/EntriesBase";

const FarmersSampleEntries: React.FC = () => {
    return <EntriesBase TabComponent={FarmersSamplesTab}
                        resultsPermission={PermissionEnum.FarmersSampleEntries}/>
}

export default FarmersSampleEntries;